import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _defineProperty from "/data/work/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import path from 'path';
import { generateTitle } from '@/utils/i18n';
import { isExternal } from '@/utils/validate';
import Item from "./Item";
import AppLink from "./Link";
import FixiOSBug from "./FixiOSBug";
export default {
  name: 'SidebarItem',
  components: {
    Item: Item,
    AppLink: AppLink
  },
  mixins: [FixiOSBug],
  props: {
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    // 新增：接收父菜单是否匹配的状态（默认false）
    parentMatched: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    this.onlyOneChild = null;
    return {
      isSubMenuOpen: false
    };
  },
  computed: {
    searchKey: function searchKey() {
      return this.$store.state.app.menuSearchKey || '';
    },
    shouldShow: function shouldShow() {
      var hasSearch = !!this.searchKey.trim();
      if (!hasSearch) return true; // 无搜索时，正常显示

      // 核心逻辑：满足以下任一条件就显示
      // 1. 自身匹配搜索词  2. 父菜单匹配（强制显示）  3. 子菜单有匹配项
      return this.isMatch(this.item) || this.parentMatched || this.hasMatchChild(this.item.children || []);
    },
    shouldExpandSubMenu: function shouldExpandSubMenu() {
      var hasSearch = !!this.searchKey.trim();
      if (!hasSearch) return false;
      // 父菜单匹配 或 自身匹配 或 子菜单有匹配项 → 展开
      return this.isMatch(this.item) || this.parentMatched || this.hasMatchChild(this.item.children || []);
    }
  },
  watch: {
    shouldExpandSubMenu: function shouldExpandSubMenu(newVal) {
      var _this = this;
      this.isSubMenuOpen = newVal;
      this.$nextTick(function () {
        if (_this.$refs.subMenu) {
          // 强制 Element UI 子菜单展开（兼容组件内部状态）
          _this.$refs.subMenu.open = newVal;
          _this.$refs.subMenu.$el.classList.toggle('is-opened', newVal);
        }
      });
    },
    searchKey: function searchKey() {
      this.isSubMenuOpen = this.shouldExpandSubMenu;
    }
  },
  mounted: function mounted() {
    this.isSubMenuOpen = this.shouldExpandSubMenu;
  },
  methods: {
    hasOneShowingChild: function hasOneShowingChild() {
      var _this2 = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var parent = arguments.length > 1 ? arguments[1] : undefined;
      var showingChildren = children.filter(function (item) {
        if (item.hidden) {
          return false;
        } else {
          _this2.onlyOneChild = item;
          return true;
        }
      });
      if (showingChildren.length === 1) {
        return true;
      }
      if (showingChildren.length === 0) {
        this.onlyOneChild = _objectSpread(_objectSpread({}, parent), {}, {
          path: '',
          noShowingChildren: true
        });
        return true;
      }
      return false;
    },
    resolvePath: function resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      return path.resolve(this.basePath, routePath);
    },
    // 新增：高亮处理标题（核心逻辑）
    highlightTitle: function highlightTitle(title) {
      if (!title || !this.searchKey.trim()) {
        // 无搜索词或标题为空，直接返回原标题（支持国际化）
        return generateTitle(title);
      }

      // 转小写处理，实现不区分大小写匹配
      var lowerTitle = title.toLowerCase();
      var lowerKey = this.searchKey.trim().toLowerCase();
      var index = lowerTitle.indexOf(lowerKey);
      if (index === -1) {
        // 无匹配，返回原标题
        return generateTitle(title);
      }

      // 拆分标题为：前缀 + 匹配关键词 + 后缀
      var prefix = title.substring(0, index);
      var match = title.substring(index, index + lowerKey.length);
      var suffix = title.substring(index + lowerKey.length);

      // 返回带高亮标签的HTML（使用v-html渲染）
      return "\n        ".concat(generateTitle(prefix), "\n        <span class=\"menu-keyword-highlight\">").concat(generateTitle(match), "</span>\n        ").concat(generateTitle(suffix), "\n      ");
    },
    generateTitle: generateTitle,
    isMatch: function isMatch(menuItem) {
      if (!menuItem.meta || !menuItem.meta.title) return false;
      var title = menuItem.meta.title.toLowerCase();
      var key = this.searchKey.trim().toLowerCase();
      return title.includes(key);
    },
    hasMatchChild: function hasMatchChild() {
      var _this3 = this;
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return children.some(function (child) {
        // 子菜单自身匹配 或 子菜单的父菜单匹配（递归传递状态） 或 孙子菜单有匹配项
        return !child.hidden && (_this3.isMatch(child) || _this3.parentMatched || _this3.hasMatchChild(child.children || []));
      });
    }
  }
};